import { TermsConditionComponent } from './terms-condition/terms-condition.component';

import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { CanEnterGuard } from './@core/services/auth/can-enter-guard/can-enter.guard';
import { SkipRegisterGuard } from './@core/services/auth/skip-register-guard/skip-register.guard';
import { PageNotFoundComponent } from './@shared/components/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'registration',
    pathMatch: 'full'
  },
  {
    path:'accountDeletion',
    component:TermsConditionComponent
  },
  {
    path: 'registration',
    loadChildren: () => import('./registration/registration.module').then(module => module.RegistrationModule),
    canLoad: [SkipRegisterGuard]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('../app/dashboard/dashboard.module').then(module => module.DashboardModule),
    canLoad: [CanEnterGuard]
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
